export const getReservableIntervalByIdFromService = ({ service, reservableIntervalId, }) => {
    return service.reservableIntervals.find((ri) => ri.value._id.toString() === reservableIntervalId).value;
};
